import React from 'react'
import PropTypes from 'prop-types'
import { useHlsPlayback } from '../../hooks/useHlsPlayback'

/**
 * Camino HLS. Tiene su propio `<video>` con un id distinto al del camino WebRTC: los dos
 * nunca se montan a la vez, y un id compartido haría que un camino heredara el elemento
 * que dejó el otro.
 */
const HlsPlayer = ({ setStreamingInProgress, streamingInProgress }) => {
  useHlsPlayback(setStreamingInProgress, streamingInProgress)

  const videoStyle = {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    backgroundColor: 'black',
  }

  return <video id="hls-video" playsInline preload="auto" muted style={videoStyle} />
}

export { HlsPlayer }

HlsPlayer.propTypes = {
  setStreamingInProgress: PropTypes.func,
  streamingInProgress: PropTypes.bool,
}
